<template>
  <div>
    <div
      class="
        is-flex is-justify-content-center is-align-items-center
        has-text-centered
      "
      v-if="
        chartData &&
        chartData.labels &&
        chartData.labels.length == 0 &&
        reportChart == null
      "
      style="height: 500px"
    >
      <div class="has-text-centered">
        <div
          style="
            height: 60px;
            width: 60px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: end;
            margin: 20px auto;
          "
        >
          <div
            class="mx-1"
            style="height: 100%; width: 20px; background-color: #f2f2f2"
          ></div>
          <div
            class="mx-1"
            style="height: 50%; width: 20px; background-color: #f2f2f2"
          ></div>
          <div
            class="mx-1"
            style="height: 30%; width: 20px; background-color: #f2f2f2"
          ></div>
        </div>
        <p class="has-text-grey">
          Select your preference filter and click generate
        </p>
      </div>
    </div>
    <div v-else>
      <div class="columns mt-2" v-if="chartItem == 2 && reportChart != null">
        <div class="column is-2">
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
            style="max-width: 200px; cursor: pointer"
          >
            <div
              class="box m-0 mr-2"
              style="border-radius: 0px; padding: 8px"
              :style="
                active.value == 'Total Points'
                  ? 'background:#00BFF7; border: 1px solid #00BFF7; trasition: ease 600ms'
                  : 'background:#00BFF7; border: 1px solid #00BFF7; trasition: ease 600ms'
              "
            ></div>
            <h6
              class="m-0 full-width"
              :class="
                active.title == 'Total Points'
                  ? 'has-text-black-bis'
                  : 'has-text-grey fw-400'
              "
            >
              Total Points
            </h6>
          </div>
        </div>
      </div>
      <div class="columns mt-2" v-if="chartItem == 1 && reportChart != null">
        <div class="column is-2">
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
            style="max-width: 200px; cursor: pointer"
            @click="
              handleChangeCategoryChart(
                'Submission Count',
                '#EC4899',
                '#EC4899',
                'Submission Count'
              )
            "
          >
            <div
              class="box m-0 mr-2"
              style="border-radius: 0px; padding: 8px"
              :style="
                active.value == 'Submission Count'
                  ? 'background:#EC4899; border: 1px solid #EC4899; trasition: ease 600ms'
                  : 'background:#EC4899; border: 1px solid #EC4899; trasition: ease 600ms'
              "
            ></div>
            <h6
              class="m-0 full-width"
              :class="
                active.value == 'Submission Count'
                  ? 'has-text-black-bis'
                  : 'has-text-grey fw-400'
              "
            >
              Submission Count
            </h6>
          </div>
        </div>
        <div class="column is-2">
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
            style="max-width: 200px; cursor: pointer"
            @click="
              handleChangeCategoryChart(
                'Total Points',
                '#00BFF7',
                '#00BFF7',
                'Total Points'
              )
            "
          >
            <div
              class="box m-0 mr-2"
              style="border-radius: 0px; padding: 8px"
              :style="
                active.value == 'Total Points'
                  ? 'background:#00BFF7; border: 1px solid #00BFF7; trasition: ease 600ms'
                  : 'background:#00BFF7; border: 1px solid #00BFF7; trasition: ease 600ms'
              "
            ></div>
            <h6
              class="m-0 full-width"
              :class="
                active.title == 'Total Points'
                  ? 'has-text-black-bis'
                  : 'has-text-grey fw-400'
              "
            >
              Total Points
            </h6>
          </div>
        </div>
        <div class="column is-2">
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
            style="max-width: 200px; cursor: pointer"
            @click="
              handleChangeCategoryChart(
                'Total Student',
                '#553AFE',
                '#553AFE',
                'Total Student'
              )
            "
          >
            <div
              class="box m-0 mr-2"
              style="border-radius: 0px; padding: 8px"
              :style="
                active.value == 'Total Student'
                  ? 'background:#553AFE; border: 1px solid #553AFE; trasition: ease 600ms'
                  : 'background:#553AFE; border: 1px solid #553AFE; trasition: ease 600ms'
              "
            ></div>
            <h6
              class="m-0 full-width"
              :class="
                active.title == 'Total Student'
                  ? 'has-text-black-bis'
                  : 'has-text-grey fw-400'
              "
            >
              Total Student
            </h6>
          </div>
        </div>
        <div class="column">
          <div
            v-if="!isLoading"
            v-show="chartData.labels.length > 31"
            class="animate-text blink_me"
            @click="
              scroll(
                scrollDirection == 'left'
                  ? 'anchorScrollLeft'
                  : 'anchorScrollRight'
              )
            "
          >
            <p class="has-text-grey has-text-right" style="cursor: pointer">
              <span v-show="scrollDirection == 'left'"
                ><i class="fa fa-angle-left"></i
                ><i class="fa fa-angle-left mr-2"></i
              ></span>
              Click or Scroll to {{ scrollDirection }}
              <span v-show="scrollDirection == 'right'"
                ><i class="fa fa-angle-right ml-2"></i
                ><i class="fa fa-angle-right"></i
              ></span>
            </p>
          </div>
        </div>
      </div>
      <div class="chartWrapper mt-2" @scroll="handleScrollingChart">
        <div
          class="chartAreaWrapper"
          :class="
            chartData && chartData.labels && chartData.labels.length > 31
              ? windowWidth < 720
                ? chartData && chartData.labels && chartData.labels.length > 31
                  ? 'is-w-5000'
                  : 'is-w-200'
                : 'is-w-10000'
              : windowWidth < 720
              ? chartData && chartData.labels && chartData.labels.length > 31
                ? 'is-w-5000'
                : 'is-w-200'
              : 'is-w-100'
          "
        >
          <div id="anchorScrollLeft"></div>
          <canvas id="reportChart"></canvas>
          <div id="anchorScrollRight"></div>
        </div>
      </div>
    </div>
    <!-- <div v-show="!isLoading && !showChart">
      <p>No Data</p>
    </div> -->
  </div>
</template>

<script>
import Chart from "chart.js";
import { putZeroInFront } from "./CustomFunction";
// let reportChart = null;
export default {
  name: "Chart",
  props: [
    "chartData",
    "isLoading",
    "options",
    "item",
    "activeChartCategory",
    "handleChangeCategoryChart",
    "chartItem",
    "typeDuration",
    "tagDataSource",
    "filterItems",
  ],
  data() {
    return {
      active: this.activeChartCategory,
      windowWidth: window.innerWidth,
      showChart: true,
      scrollDirection: "right",
      studentReportChartData: {
        type: "bar",
        data: [],
        options: this.options,
      },
      reportChart: null,
    };
  },
  watch: {
    chartItem() {
      if (this.reportChart) {
        this.reportChart = this.reportChart.clear();
        this.reportChart = null;
      }
    },
    activeChartCategory() {
      this.active = this.activeChartCategory;
    },
    chartData() {
      if (
        this.chartData &&
        this.chartData.labels &&
        this.chartData.labels.length == 0
      ) {
        this.showChart = false;
        if (this.reportChart != null) {
          this.reportChart = this.reportChart.destroy();
          this.reportChart = null;
        }
      } else {
        this.showChart = true;
        setTimeout(() => {
          this.drawChart();
        }, 500);
      }
    },
    windowWidth(newWidth, oldHeight) {
      // const ctx = document.getElementById("reportChart");
      // let date = new Date();
      // let year = date.getFullYear();
      // let month = date.getMonth();
      // let day = date.getDate();
      // const monthNames = [
      //   "Jan",
      //   "Feb",
      //   "Mar",
      //   "Apr",
      //   "May",
      //   "June",
      //   "Jul",
      //   "Aug",
      //   "Sep",
      //   "Oct",
      //   "Nov",
      //   "Dec",
      // ];
      // let currentDate = `${putZeroInFront(day)} ${monthNames[month]} ${year}`;
      // if (newWidth < 720) {
      //   this.studentReportChartData = {
      //     ...this.studentReportChartData,
      //     type: "horizontalBar",
      //     options: {
      //       ...this.studentReportChartData.options,
      //       scales: {
      //         ...this.studentReportChartData.options.scales,
      //         xAxes: [
      //           {
      //             ...this.studentReportChartData.options.scales.xAxes[0],
      //             display: false,
      //             ticks: {
      //               ...this.studentReportChartData.options.scales.xAxes[0]
      //                 .ticks,
      //               display: false,
      //             },
      //           },
      //         ],
      //         yAxes: [
      //           {
      //             ...this.studentReportChartData.options.scales.yAxes[0],
      //             display: true,
      //             ticks: {
      //               ...this.studentReportChartData.options.scales.yAxes[0]
      //                 .ticks,
      //               display: true,
      //               labelOffset: this.typeDuration > 3 ? -8 : 0,
      //               callback: function (value, index, values) {
      //                 let name = "";
      //                 if (typeof value == "string") {
      //                   let label = value.split(" ");
      //                   if (this.typeDuration <= 3 && this.chartItem == 1) {
      //                     name =
      //                       value === currentDate
      //                         ? "Today"
      //                         : `${parseInt(label[0])} ${label[1]}`;
      //                   } else {
      //                     name = value;
      //                   }
      //                 } else {
      //                   name = value;
      //                 }
      //                 return name;
      //               },
      //             },
      //           },
      //         ],
      //       },
      //     },
      //   };
      //   if (
      //     this.chartData &&
      //     this.chartData.labels &&
      //     this.chartData.labels.length > 30
      //   ) {
      //     console.log(ctx.height);
      //     ctx.height = 8000;
      //   } else {
      //     ctx.height = 4500;
      //   }
      //   ctx.width = 0;
      //   this.drawChart();
      // } else {
      //   this.studentReportChartData = {
      //     ...this.studentReportChartData,
      //     type: "bar",
      //     options: {
      //       ...this.options,
      //       tooltips: {
      //         position: "custom", //<-- important same name as your function above
      //         callbacks: {
      //           label: function (tooltipItem, data) {
      //             var label =
      //               Math.floor(tooltipItem.yLabel * 100) / 100 +
      //               " " +
      //               data.datasets[tooltipItem.datasetIndex].label;
      //             return label;
      //           },
      //         },
      //       },
      //       scales: {
      //         ...this.options.scales,
      //         xAxes: [
      //           {
      //             ...this.options.scales.yAxes[0],
      //             display: true,
      //             ticks: {
      //               ...this.options.scales.yAxes[0].ticks,
      //               display: true,
      //               labelOffset: this.typeDuration > 3 ? -8 : 0,
      //               callback: function (value, index, values) {
      //                 let name = "";
      //                 if (typeof value == "string") {
      //                   let label = value.split(" ");
      //                   if (this.typeDuration <= 3 && this.chartItem == 1) {
      //                     name =
      //                       value === currentDate
      //                         ? "Today"
      //                         : `${parseInt(label[0])} ${label[1]}`;
      //                   } else {
      //                     name = value;
      //                   }
      //                 } else {
      //                   name = value;
      //                 }
      //                 return name;
      //               },
      //               maxRotation: 90,
      //               minRotation: 90,
      //             },
      //           },
      //         ],
      //         yAxes: [
      //           {
      //             ...this.options.scales.yAxes[0],
      //             display: false,
      //             ticks: {
      //               ...this.options.scales.yAxes[0].ticks,
      //               display: false,
      //             },
      //           },
      //         ],
      //       },
      //     },
      //   };
      //   ctx.height = 520;
      //   ctx.width = 1000;
      //   this.drawChart();
      // }
      // reportChart.resize();
      return newWidth;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    scroll(refName) {
      var element = document.getElementById(refName);
      element.scrollIntoView({ behavior: "smooth" });
    },
    handleScrollingChart(e) {
      let { target } = e;
      if (target.scrollLeft > 0) {
        this.scrollDirection = "left";
      } else {
        this.scrollDirection = "right";
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    drawChart() {
      if (this.reportChart != null) {
        this.reportChart = this.reportChart.destroy();
        this.reportChart = null;
      }

      if (this.chartData != null) {
        Chart.Tooltip.positioners.custom = function (elements, eventPosition) {
          /** @type {Chart.Tooltip} */
          var tooltip = this;

          /* ... */

          return {
            x: eventPosition.x,
            y: eventPosition.y,
          };
        };

        const ctx = document.getElementById("reportChart");
        ctx.width = 1000;
        ctx.height = 700;

        let type = this.typeDuration;

        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "June",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];

        let currentDate = `${putZeroInFront(day)} ${monthNames[month]} ${year}`;
        let behaviorType = this.chartItem == 1 ? "items" : "category";

        this.reportChart = new Chart(ctx, {
          ...this.studentReportChartData,
          options: {
            ...this.studentReportChartData.options,
             plugins: {
               ...this.studentReportChartData.options.plugins,
               datalabels: {
                  ...this.studentReportChartData.options.plugins.datalabels,
                  rotation: -60
               }
            },
            tooltips: {
              position: "custom", //<-- important same name as your function above
              callbacks: {
                label: function (tooltipItem, data) {
                  var label =
                    Math.floor(tooltipItem.yLabel * 100) / 100 +
                    " " +
                    data.datasets[tooltipItem.datasetIndex].label;
                  return label;
                },
              },
            },
            scales: {
              ...this.studentReportChartData.options.scales,
              xAxes: [
                {
                  ...this.studentReportChartData.options.scales.xAxes[0],
                  ticks: {
                    ...this.studentReportChartData.options.scales.xAxes[0]
                      .ticks,
                    labelOffset: type > 3 ? -8 : 0,
                    callback: function (value, index, values) {
                      let name = "";
                      if (typeof value == "string") {
                        let label = value.split(" ");
                        if (
                          (type == 1 || type == 2) &&
                          behaviorType == "items"
                        ) {
                          name =
                            value === currentDate
                              ? "Today"
                              : `${parseInt(label[0])} ${label[1]}`;
                        } else {
                          name = value;
                        }
                      } else {
                        name = value;
                      }
                      return name;
                    },
                  },
                },
              ],
            },
          },
          data:
            this.chartItem == 1
              ? {
                  ...this.chartData,
                  datasets: this.chartData.datasets.filter(
                    (x) => x.label === this.activeChartCategory.value
                  ),
                }
              : this.chartData,
        });
      }
    },
  },
};
</script>
<style >
.fw-400 {
  font-weight: 500 !important;
}
.chartWrapper {
  position: relative;
  overflow: scroll;
}

.chartWrapper > canvas {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.chartAreaWrapper {
  height: 100%;
  display: flex;
}

.is-w-5000 {
  width: 5000px;
}

.is-w-10000 {
  width: 5000px;
}
.is-w-500 {
  width: 500vh;
}

.is-w-200 {
  width: 200vh;
}

.is-w-100 {
  width: 100%;
}

.is-borderless {
  border: 0px !important;
}

.full-width {
  width: 100%;
}

.animate-text {
  position: relative;
  /* padding-top: 16px; */
  padding-left: 12px;
  font-size: 14px;
  color: #c9c9c9;
  opacity: 100%;
}

.blink_me {
  animation: blinker 1s linear infinite;
  right: 0px;
  opacity: 50%;
}

@keyframes blinker {
  50% {
    right: 5px;
  }
}

@media (max-width: 720px) {
  /* .chartWrapper {
    height: 100%;
  }
  .chartAreaWrapper {
    height: 500vh;
    width: 100%;
  }

  .is-w-5000,
  .is-w-10000,
  .is-w-500,
  .is-w-200,
  .is-w-100 {
    width: 100%;
  } */
}
</style>


// WEBPACK FOOTER //
// src/components/OverallReporting/Chart.vue